import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { PlaneTakeoff, Settings, Zap, Package, Cpu, Truck } from 'lucide-react';
export function TransportationServices() {
  const services = [{
    icon: PlaneTakeoff,
    title: 'Aircraft Engines',
    description: 'Safe and secure transport of turbine and piston engines nationwide.'
  }, {
    icon: Settings,
    title: 'Landing Gear',
    description: 'Specialized handling and delivery of landing gear assemblies.'
  }, {
    icon: Zap,
    title: 'APUs & Components',
    description: 'Auxiliary power units and critical aircraft components, delivered on time.'
  }, {
    icon: Package,
    title: 'Aviation Parts & Components',
    description: 'Full chain-of-custody transport for all aviation parts and hardware.'
  }, {
    icon: Cpu,
    title: 'Avionics Equipment',
    description: 'Sensitive avionics handled with expert care and proper packaging.'
  }, {
    icon: Truck,
    title: 'Airframes & Specialized Cargo',
    description: 'Oversized and specialized cargo with flatbeds, step decks and conestogas.'
  }];
  return <section id="services" className="py-24 bg-navy-light relative border-b border-white/5" data-id="element-361">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-362">
        <div className="text-center mb-16" data-id="element-363">
          <span className="text-gold text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-364">
            What We Transport
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-365">
            Specialized Aviation Cargo Transport
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-366">
            Safe, secure and time-critical delivery of aviation components
            across the United States.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-367">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy rounded-2xl p-8 border border-white/5 hover:border-gold/30 transition-all group relative overflow-hidden flex flex-col h-full" data-id="element-368">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gold/5 rounded-bl-full -mr-16 -mt-16 transition-transform group-hover:scale-110 pointer-events-none" data-id="element-369"></div>

              <div className="w-14 h-14 rounded-full bg-navy-light border border-gold/20 flex items-center justify-center mb-6 relative z-10 group-hover:shadow-gold-glow transition-all shrink-0" data-id="element-370">
                <service.icon className="w-7 h-7 text-gold" data-id="element-371" />
              </div>

              <h3 className="text-xl font-heading font-bold text-white mb-3 uppercase tracking-wide relative z-10" data-id="element-372">
                {service.title}
              </h3>
              <p className="text-slate-300 leading-relaxed relative z-10 text-base" data-id="element-373">
                {service.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy border border-gold/20 rounded-xl p-6 text-center mb-12" data-id="element-374">
          <p className="text-gold font-medium text-sm md:text-base tracking-wide" data-id="element-375">
            <span className="text-white font-bold mr-2" data-id="element-376">
              Specialized Equipment:
            </span>
            Flatbeds · Step Decks · Conestogas · Hot Shot · Expedited · Oversize
            Permits
          </p>
        </motion.div>

        <div className="text-center" data-id="element-377">
          <a href="#contact" className="inline-block bg-gold hover:bg-gold-light text-navy font-bold py-4 px-10 rounded-full transition-all shadow-gold-glow hover:shadow-gold-glow-lg transform hover:-translate-y-1 text-lg" data-id="element-378">
            Request a Transport Quote
          </a>
        </div>
      </div>
    </section>;
}